function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Alert, Tag } from 'antd';
import Common from "../includes/Common";
import { Editor } from "@tinymce/tinymce-react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EditLaboResult = function EditLaboResult(_ref) {
  var result = _ref.result,
    q_item = _ref.q_item,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    resultString = _useState8[0],
    setResultString = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    sampleId = _useState10[0],
    setSampleId = _useState10[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleRsChange = function handleRsChange(e) {
    setResultString(e);
  };
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("result_string", resultString);
    formData.append("sample_id", values.sampleid);
    formData.append("rid", result.id);
    axios.post(Common.baseApiUrl + "editlaboresult", formData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage("Résultats saisis avec succès");
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
      handler();
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    setResultString(result.result_string);
    setSampleId(result.result_id);
    form.setFieldsValue({
      sampleid: result.sample_id
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Descriptions, {
      size: "small",
      bordered: true,
      column: 1,
      children: /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Examen(s) demand\xE9(s)",
        children: q_item != null && q_item.queue_item_elements.map(function (e) {
          return /*#__PURE__*/_jsx(Tag, {
            color: "red",
            children: /*#__PURE__*/_jsx("b", {
              children: e.medical_item.label
            })
          }, e.id);
        })
      })
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "sampleid",
        label: "N. Echantillon",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Editor, {
        apiKey: "69tgdaxlfgnfvq8zykq31unfidbs0funxod1ykdzi3nslx1t",
        init: {
          menubar: true,
          height: 500,
          plugins: "link image code autoresize lists",
          toolbar: "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help"
        },
        value: resultString,
        onEditorChange: handleRsChange
      }), /*#__PURE__*/_jsxs(Form.Item, {
        children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
          message: errorMessage,
          type: "error",
          banner: true
        }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
          message: successMessage,
          type: "success",
          banner: true
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: "Sauvegarder"
        })
      })]
    })]
  });
};
export default EditLaboResult;